module.exports = __webpack_public_path__ + "878c920575bab3f2865026299e30f0bf.svg";